import _ from 'underscore';
import Uri from 'urijs';
import { isMultiAgencyBillingEnabled } from '@bingads-webui/multi-agency-utils';

export const getAccountLinkPermissionType = (serverContext) => {
  const currentUrl = new Uri(window.location.href);
  const queryParams = currentUrl.search(true); // Get query parameters as an object
  return queryParams.aid && Number(queryParams.aid) > 0 ? _.get(serverContext, 'AccountLinkPermissionType') : undefined;
};

export const initSettingsContext = (serverContext, permissions) => {
  const settingsContext = {
    Urls: {
      ...serverContext.Urls,
      SmartBaseUrl: new Uri(`${serverContext.Urls.RootUIUrl}/campaign/smart/`).normalize().toString(),
      AdInsightBaseUrl: new Uri(`${serverContext.Urls.RootUIUrl}/research/vnext/`).normalize().toString(),
      UnifiedProductBaseUrl: new Uri(`${serverContext.Urls.RootUIUrl}/campaign/mca/`).normalize().toString(),
    },
  };

  if (isMultiAgencyBillingEnabled(permissions)) {
    settingsContext.AccountLinkPermissionType = getAccountLinkPermissionType(serverContext);
  }

  return settingsContext;
};
